import { experimentSettings } from "@/constants/experiments";
import { hasSettingEqualTo } from "@/helpers/experiment-helper";

const PARTS_API_V1 = "/parts/api/v1/";
const PARTS_API_V2 = "/parts/api/v2/";

export function useCoreServicesPartService(experimentSettingsMap) {
    return hasSettingEqualTo(
        experimentSettings.USER_CORE_SERVICES_PART_SERVICE,
        "true",
        experimentSettingsMap
    );
}

export function resolvePartsApiUrl(url, experimentSettingsMap = {}, vinRequired = false) {
    if (!url?.includes("/parts/api/") || url?.includes("supporting-items")) {
        return url;
    }

    // VinRequired vehicles must stay on Parts v2 even when the experiment would override to v1.
    const useV2 = vinRequired || useCoreServicesPartService(experimentSettingsMap);
    if (useV2) {
        return url.replace(PARTS_API_V1, PARTS_API_V2);
    }
    return url.replace(PARTS_API_V2, PARTS_API_V1);
}
